CustomTC.define('modules/player-ui',['modules/util', 'modules/core', 'modules/constants', 'modules/options', 'modules/language', 'modules/recast/recast', 'modules/share/share', 'modules/comments/comments', 'modules/settings/settings', 'modules/transcriptions/transcriptions', 'modules/load-data', 'modules/flag', 'modules/chat/chat', 'modules/thumbs/thumbs', 'modules/presence/presence', 'modules/search/search', 'modules/logger', 'modules/stats/stats', 'text!modules/htmls/main.html', 'text!modules/htmls/loading.html', 'text!modules/htmls/loading-vapp.html', 'text!modules/htmls/controls.html', 'text!modules/htmls/progress-panel.html', 'text!modules/htmls/info-panel.html', 'text!modules/htmls/end-overlay.html', 'text!modules/htmls/embed.html', 'text!modules/htmls/explore-overlay.html', 'css!modules/css/common', 'css!modules/css/loading', 'css!modules/css/loading-vapp', 'css!modules/css/controls', 'css!modules/css/progress-panel', 'css!modules/css/end-overlay', 'css!modules/css/explore-overlay', 'css!modules/css/embed', 'css!modules/css/info-panel'], function(util, core, constants, options, language, recast, share, comment, settings, transcriptions, loadData, flag, chat, thumbs, presence, search, logger, stats, main, loading, loadingVapp, controls, progress, info, endOverlay, embed, exploreOverlay) {
    return {
        recastInited: 0,
        // init player ui
        init: function(config) {
            var mainContainer = core.init(main);
            /*if (typeof config.domain != 'undefined' && config.domain != '') {
                endOverlay = endOverlay.replace('{{host}}', config.domain);
            } else {
                endOverlay = endOverlay.replace('{{host}}', '');
            }*/
            endOverlay = endOverlay.replace('{{host}}', 'http://www.touchcast.com');
            mainContainer.find('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + '').append(loading);
            mainContainer.find('.' + constants.CSS_TOUCHCAST_PLAYER_TOOLS + '').append(controls);
            //     .append(progress)
            //     .append(info);
            mainContainer.find('.' + constants.CSS_TOUCHCAST_PLAYER_CONTAINER + '').append(exploreOverlay)
                .append(endOverlay)
                .append(embed);

            var rgba = util.hexToRgba(options.getControlsColor(), 80);
            // skin color
            core.init('<style> .tcCustomBg, .tcPlayerHeaderHover, .tcCustomBgHover.active, .active .tcCustomBgHover, .tcCustomBgHover.selected, .tcCustomBgBdrHover.active, .tcCustomBgBdrHover.hover { background-color: #' + options.getSkinColor() + ' !important; cursor: pointer; } .tcCustomBgBdrHover.active, .tcCustomBgBdrHover.hover, .tcCustomBdrHover.active, .tcCustomBdrHover.current, .tcCustomBdr { border-color: #' + options.getSkinColor() + ' !important; cursor: pointer; } .active .tcCustomColorHover { color: #' + options.getSkinColor() + ' !important; cursor: pointer; } } </style>').appendTo(document.documentElement);
            // controls color
            core.init('<style> .tcControls{ background: #' + options.getControlsColor() + '; } .tcControls .tcPlayButton, .tcControls .tcPauseButton, .volume-container .volume, .volume-container .mute{ background-color: #' + options.getControlsColor() + '; cursor: pointer; } .volume-container .volume-control{ background: #' + options.getControlsColor() + '; } </style>').appendTo(document.documentElement);
            // controls divider color
            core.init('<style> .tcPlayerTools .divider{ background: #' + options.getControlsDividerColor() + '; } </style>').appendTo(document.documentElement);
            // player background color
            core.init('<style> .tcPlayer{ background: #' + options.getPlayerBackgroundColor() + '; } </style>').appendTo(document.documentElement);
            // progress update color
            core.init('<style> .tcProgressPanel .tcProgressPlaying{ background-color: ' + options.getProgressUpdateColor() + ' !important; } </style>').appendTo(document.documentElement);
            // infobar color
            core.init('<style> .tcInfoBarContainer{ background-color: ' + rgba + ' !important; border: 1px solid #' + options.getControlsDividerColor() + ' !important; } .tcInfoBarContainer .info-desc:after{background: ' + rgba + ';} </style>').appendTo(document.documentElement);
            // share panel color
            core.init('<style> .tcSharePanel{ background-color: ' + rgba + ' !important;  border: 1px solid #' + options.getControlsDividerColor() + ' !important; } </style>').appendTo(document.documentElement);
            // add color of live text
            core.init('<style> .tcControls .tcLiveDuration { color: #' + options.getSkinColor() + ' !important; } </style>').appendTo(document.documentElement);
            // add color of progress time guide
            core.init('<style> .tcProgressPanel .tcTimeCodeGuide:after { border-color: #' + options.getSkinColor() + '; } .tcProgressPanel .tcTimeCodeGuide { background: #' + options.getSkinColor() + ' !important; } .tcProgressPanel .tcTrackGuide { background: #' + options.getSkinColor() + ' !important; } </style>').appendTo(document.documentElement);
            // add color of pip wrapper
            core.init('<style> .tcPipWrapper { border: 40px solid  #' + options.getSkinColor() + ' !important; } .tcPipWrapper .tcPipReturnContainer { background: #' + options.getSkinColor() + ' !important; }  </style>').appendTo(document.documentElement);
            // add color of dropdowns
            core.init('<style> .tcSharePanel .dropdown-menu , .settingsValues .dropdown-menu { background-color: ' + rgba + ' !important;  border: 1px solid #' + options.getControlsDividerColor() + ' !important; }   </style>').appendTo(document.documentElement);
            // subtitles background color
            if (options.getSubtitlesBackgroundColor() !== 'f15d50') {
                // add color of subtitles background
                core.init('<style> .transcript a { background-color: #' + options.getSubtitlesBackgroundColor() + ' !important; box-shadow: 10px 0 0 #' + options.getSubtitlesBackgroundColor() + ', -10px 0 0 #' + options.getSubtitlesBackgroundColor() + ' !important; }  </style>').appendTo(document.documentElement);
            } else {
                // add color of subtitles background
                core.init('<style> .transcript a { background-color: #' + options.getSkinColor() + ' !important; box-shadow: 10px 0 0 #' + options.getSkinColor() + ', -10px 0 0 #' + options.getSkinColor() + ' !important; }  </style>').appendTo(document.documentElement);
            }
            // subtitles text color
            core.init('<style> .transcript a { color: #' + options.getSubtitlesTextColor() + ' !important; }  </style>').appendTo(document.documentElement);
            // volume icon before color
            core.init('<style> .volume-container .volume:before {background-color: #' + options.getControlsColor() + ' !important;border-right: 1px solid #' + options.getControlsDividerColor() + ' !important;} .volume-container .volume.active:before {background: #' + options.getSkinColor() + ' !important;} </style>').appendTo(document.documentElement);

            var ieVer = util.getIEVersion();
            if (ieVer !== undefined && parseInt(ieVer) > 0) {
                core.addClass(mainContainer, 'ie');
                core.addClass(mainContainer, 'ie' + ieVer);
                if (ieVer < 11)
                    core.addClass(mainContainer, 'ielt11');
                if (ieVer < 10)
                    core.addClass(mainContainer, 'ielt10');
                if (ieVer < 9)
                    core.addClass(mainContainer, 'ielt9');
                if (ieVer < 8)
                    core.addClass(mainContainer, 'ielt8');
            }
            if (util.isAndroid()) {
                core.addClass(core.init('body'), 'droid');
                core.addClass(mainContainer, 'droid');
            }

            if (util.isiPad() || util.isiPhone() || util.isiPod()) {
                core.addClass(mainContainer, 'ios');
                core.addClass(core.init('body'), 'ios');
                if (util.isiPad())
                    core.addClass(mainContainer, 'ipad');
                else
                    core.addClass(mainContainer, 'iphone');
            }
            if (typeof config.element === 'undefined')
                core.init('body').append(mainContainer);
            else
                core.init(config.element).append(mainContainer);

            if (ieVer !== undefined && parseInt(ieVer) > 0)
                this.ieFixes(ieVer);

            /*if (window.parent == window && window.navigator.userAgent.indexOf('Safari') !== -1 && (util.isiPhone() || util.isiPod())) {
                var body = core.init('body');
                var iPhoneOverlay = core.init('<div />');
                core.addClass(iPhoneOverlay, constants.CSS_TOUCHCAST_IPHONE_OVERLAY);
                iPhoneOverlay.append('<div class="' + constants.CSS_TOUCHCAST_IPHONE_SCROLL_UP + '"></div>')
                body.append(iPhoneOverlay);

                var win = core.init(window);
                core.off(win, 'scroll');
                core.on(win, 'scroll', function(e) {
                    if (!options.getShowiPhoneOverlay()) {
                        e.preventDefault();
                        e.stopPropagation();
                        win.scrollTop(0, 1);
                        return false;
                    }
                });

                core.off(body, 'touchstart touchmove touchend');
                core.on(body, 'touchstart touchmove touchend', function(e) {
                    if (!options.getShowiPhoneOverlay()) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                });
            }*/
        },
        ieFixes: function(ver) {
            if (ver < 10) {
                var mainLoadSpinner = core.init('#' + constants.CSS_TOUCHCAST_LOADING_WRAPPER + ' .' + constants.CSS_TOUCHCAST_LOADING_SPINNER + '');
                core.html(mainLoadSpinner, language.getLoadingText());
                core.setCss(mainLoadSpinner, {
                    color: '#' + options.getSkinColor(),
                    marginTop: -(core.getHeight(mainLoadSpinner) / 2) - 74 + 'px',
                    marginLeft: -(core.getWidth(mainLoadSpinner) / 2) + 'px'
                });
            }
        },
        initShare: function() {
            if (share)
                share.init(this);
        },
        updateSharePanel: function() {
            if (share)
                share.updateInfo();
        },
        initComment: function(video, isAjaxAllowed) {
            comment.clearComments();
            comment.init(this, video, isAjaxAllowed);
        },
        initChat: function(video) {
            chat.init(this, video);
        },
        receiveChat: function(data) {
            chat.receiveChat(data);
        },
        initSearch: function(video) {
            if (options.getEnableSearch()) {
                search.init(this, video);
            }
        },
        initThumbs: function(video) {
            thumbs.init(this, video);
        },
        receiveThumbs: function(data) {
            thumbs.receiveThumbs(data);
        },
        initPresence: function(video) {
            presence.init(this, video);
        },
        usersViewing: function(data) {
            presence.usersViewing(data);
        },
        initStats: function(player, config) {
            stats.init(this, player, config);
        },
        hideDebugMenu: function() {
            return stats.toggleMenuOff();
        },
        initModal: function() {
            var modalCloseBtn = core.init('.' + constants.CSS_TOUCHCAST_MODAL_BOX + ' .' + constants.CSS_TOUCHCAST_MODAL_CLOSE + '');
            core.off(modalCloseBtn, 'touchstart click');
            core.on(modalCloseBtn, 'touchstart click', function(e) {
                e.preventDefault();
                core.removeClass(core.init(this).parents('.' + constants.CSS_TOUCHCAST_MODAL_BOX + ''), constants.CSS_TOUCHCAST_OPEN);
                return false;
            });
        },
        initSettings: function(player) {
            if (settings) {
                settings.init(this);
                this.setPlayerLanguageForSettingsPanel();
                player.initTranscriptionSelection(transcriptions);
            }
        },
        initTranscriptions: function(subtitles, player) {
            if (transcriptions) {
                transcriptions.init(this, subtitles);
                player.initTranscriptions(transcriptions);
            }
        },
        getTranscriptions: function() {
            if (transcriptions) {
                return transcriptions.transcript;
            }
        },
        transcriptionEnabled: function() {
            if (transcriptions) {
                return transcriptions.transcriptionEnabled;
            }
        },
        initEndScreen: function(hasShare, player) {
            var self = this;
            var endShare = core.init('#' + constants.CSS_TOUCHCAST_END_SHARE_BUTTON + '');
            if (hasShare !== 0) {
                core.off(endShare, 'touchstart click');
                core.on(endShare, 'touchstart click', function(e) {
                    e.preventDefault();
                    share.showSharePopup(core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SHARE + ''), core.init('.' + constants.CSS_TOUCHCAST_SHARE_PANEL + ''));
                    return false;
                });
            } else {
                core.addClass(endShare.parent(), constants.CSS_TOUCHCAST_HIDE);
            }

            var endDownload = core.init('#' + constants.CSS_TOUCHCAST_END_DOWNLOAD_BUTTON + '');
            core.off(endDownload, 'touchstart click');
            core.on(endDownload, 'touchstart click', function(e) {
                e.preventDefault();
                TouchCast.InteractiveLayer.openPipMode(core.getAttr(core.init(this), 'href'));
                return false;
            });

            var endReplay = core.init('#' + constants.CSS_TOUCHCAST_END_REPLAY_BUTTON + '');
            core.off(endReplay, 'touchstart click');
            core.on(endReplay, 'touchstart click', function(e) {
                e.preventDefault();
                player.resumeVideo();
                return false;
            });

            if (util.getIEVersion() === 8) {
                var shareIcon = core.find(endShare, 'i');
                var downloadIcon = core.find(endDownload, 'i');
                var replayIcon = core.find(endReplay, 'i');
                core.removeClass(shareIcon, 'end-icon-forward');
                core.addClass(shareIcon, 'end-icon-macstore');
                core.removeClass(downloadIcon, 'end-icon-macstore');
                core.addClass(downloadIcon, 'end-icon-cw');
                core.removeClass(replayIcon, 'end-icon-cw');
                core.addClass(replayIcon, 'end-icon-forward');
                var endScreen = core.init('.' + constants.CSS_TOUCHCAST_VIDEO_END_OVERLAY + '');
                core.setCss(endScreen, {
                    marginTop: -(core.getHeight(endScreen) / 2) + 'px'
                });
            }
        },
        showEndScreen: function() {
            var endScreen = core.init('.' + constants.CSS_TOUCHCAST_VIDEO_END_OVERLAY + '');
            core.fadeIn(endScreen, 'slow', function() {
                core.removeClass(endScreen, constants.CSS_TOUCHCAST_HIDE);
            });
        },
        playVideo: function() {
            var hasWebmVideo = (videoInfo[0].videoWebm) ? true : '';
            if (TouchCast.InteractiveLayer.getPlayerMode(hasWebmVideo) === 'html5') {
                core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0].play();
            } else {
                options.getFlashMovie()['TouchCast.FlashSDK.Fallback.resumeVideo']();
            }
        },
        showLoading: function() {
            var loadingEle = core.init('#' + constants.CSS_TOUCHCAST_LOADING_WRAPPER + '.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + '');
            core.addClass(loadingEle, constants.CSS_TOUCHCAST_PLAYER_LOADING);
            core.show(loadingEle);
        },
        showControls: function() {
            core.setCss(core.init('.' + constants.CSS_TOUCHCAST_CONTROLS + ''), {
                'visibility': 'visible'
            });
        },
        getPoster: function() {
            var mainPlayButtonTitle = language.getPlayTooltip();
            var iPhonePlayTip = options.getiPhonePlayTip();
            if (options.getAutoPlay() === 1) {
                if (iPhonePlayTip !== '' && iPhonePlayTip && iPhonePlayTip !== null) {
                    if (options.getMainPlayButton() === true || util.isiPad() || util.isiPhone() || util.isiPod()) {
                        if (options.getMainPlayButtonPosition() === 'bottom-right') {
                            return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_BOTTOM_RIGHT + '"><div class="' + constants.CSS_TOUCHCAST_IPHONE_PLAY_TAP_TIP + '">' + iPhonePlayTip + '</div><a class="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '" id="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_ID + '" title="' + mainPlayButtonTitle + '"  data-toggle="tooltip" data-original-title="' + mainPlayButtonTitle + '" style="display:none"></a></div></div>');
                        } else {
                            return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '"><div class="' + constants.CSS_TOUCHCAST_IPHONE_PLAY_TAP_TIP + '">' + iPhonePlayTip + '</div><a class="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '" id="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_ID + '" title="' + mainPlayButtonTitle + '"  data-toggle="tooltip" data-original-title="' + mainPlayButtonTitle + '" style="display:none"></a></div></div>');
                        }
                    } else {
                        return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '"><div class="' + constants.CSS_TOUCHCAST_IPHONE_PLAY_TAP_TIP + '" style="display:none">' + iPhonePlayTip + '</div></div></div>');
                    }
                } else {
                    if (options.getMainPlayButton() === true || util.isiPad() || util.isiPhone() || util.isiPod()) {
                        if (options.getMainPlayButtonPosition() === 'bottom-right') {
                            return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_BOTTOM_RIGHT + '"><a class="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '" id="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_ID + '" title="' + mainPlayButtonTitle + '"  data-toggle="tooltip" data-original-title="' + mainPlayButtonTitle + '" style="display:none"></a></div></div>');
                        } else {
                            return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '"><a class="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '" id="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_ID + '" title="' + mainPlayButtonTitle + '"  data-toggle="tooltip" data-original-title="' + mainPlayButtonTitle + '" style="display:none"></a></div></div>');
                        }
                    } else {
                        return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '"></div></div>');
                    }
                }
            } else {
                if (iPhonePlayTip !== '' && iPhonePlayTip && iPhonePlayTip !== null) {
                    if (options.getMainPlayButton() === true || util.isiPad() || util.isiPhone() || util.isiPod()) {
                        if (options.getMainPlayButtonPosition() === 'bottom-right') {
                            return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_BOTTOM_RIGHT + '"><div class="' + constants.CSS_TOUCHCAST_IPHONE_PLAY_TAP_TIP + '">' + iPhonePlayTip + '</div><a class="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '" id="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_ID + '" title="' + mainPlayButtonTitle + '"  data-toggle="tooltip" data-original-title="' + mainPlayButtonTitle + '"></a></div></div>');
                        } else {
                            return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '"><div class="' + constants.CSS_TOUCHCAST_IPHONE_PLAY_TAP_TIP + '">' + iPhonePlayTip + '</div><a class="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '" id="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_ID + '" title="' + mainPlayButtonTitle + '"  data-toggle="tooltip" data-original-title="' + mainPlayButtonTitle + '"></a></div></div>');
                        }
                    } else {
                        return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '"><div class="' + constants.CSS_TOUCHCAST_IPHONE_PLAY_TAP_TIP + '">' + iPhonePlayTip + '</div></div></div>');
                    }
                } else {
                    if (options.getMainPlayButton() === true || util.isiPad() || util.isiPhone() || util.isiPod()) {
                        if (options.getMainPlayButtonPosition() === 'bottom-right') {
                            return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_BOTTOM_RIGHT + '"><a class="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '" id="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_ID + '" title="' + mainPlayButtonTitle + '"  data-toggle="tooltip" data-original-title="' + mainPlayButtonTitle + '"></a></div></div>');
                        } else {
                            return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '"><a class="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '" id="' + constants.CSS_TOUCHCAST_MAIN_PLAY_BUTTON_ID + '" title="' + mainPlayButtonTitle + '"  data-toggle="tooltip" data-original-title="' + mainPlayButtonTitle + '"></a></div></div>');
                        }
                    } else {
                        return core.init('<div class="' + constants.CSS_TOUCHCAST_POSTER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + ' ' + constants.CSS_TOUCHCAST_NO_FLASH_HIDE + '"><div class="hide ' + constants.CSS_TOUCHCAST_MAIN_PLAY_CONTAINER + ' ' + constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY + '"></div></div>');
                    }
                }
            }
        },
        initHoverActive: function() {
            if (util.isiPad() || util.isiPhone() || util.isiPod() || util.isAndroid())
                return false;
            var hoverActive = core.init('.' + constants.CSS_TOUCHCAST_HOVER_ACTIVE + '');
            //core.off(hoverActive, 'mouseenter mouseleave');
            core.on(hoverActive, 'mouseenter', function() {
                core.addClass(core.init(this), constants.CSS_TOUCHCAST_ACTIVE);
            });
            core.on(hoverActive, 'mouseleave', function() {
                core.removeClass(core.init(this), constants.CSS_TOUCHCAST_ACTIVE);
            });
        },
        buildUI: function(video) {
            var self = this;
            logger.log('Building UI');
            this.showLoading();
            this.showControls();

            if (options.getInteractiveTip() === true) {
                var tapOrClickNode = core.init('.' + constants.CSS_TOUCHCAST_TAP_OR_CLICK_CONTAINER + '');
                core.fadeIn(tapOrClickNode, 'fast');
            }
            var posterWithPlayBtn = this.getPoster();
            var webmVideoSrcNode = posterImgNode = '';
            core.html(options.elem, '');

            var videoWrapper = core.init('<div id="' + constants.CSS_TOUCHCAST_VIDEO_WRAPPER + '"></div>');
            var videoWrapperHeightAligner = core.init('<div class="' + constants.CSS_TOUCHCAST_VIDEO_HEIGHT_ALIGNER + '"></div>');

            if (!options.isHls()) {
                var mp4VideoSrcNode = core.init('<source type="video/mp4">');
                var videoNode = core.init('<video id="' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '" type="video/mp4" width="100%" height="100%" webkit-playsinline="" playsinline="" preload="none"></video>');
                var mp4VideoSrc = video.video_url;
                mp4VideoSrcNode[0].addEventListener('error', function() {
                    self.showError();
                }, false);
            } else {
                var videoNode = core.init('<video crossOrigin="anonymous" id="' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '" width="100%" height="100%" webkit-playsinline="" playsinline="" preload="none"></video>');
                var mp4VideoSrc = video;
                var mp4VideoSrcNode = core.init('<source crossOrigin="anonymous" type="application/x-mpegURL">');
            }

            //logger.log('check type of touchcast',options.getTcVideoType());

            if (options.isHls() || options.getOriginalHls() !== '' || video.tc_type === 'livestream') {
                core.addClass(videoWrapper, constants.CSS_TOUCHCAST_VIDEO_WRAPPER_LIVESTREAM);
                // core.addClass(core.init('.' + constants.CSS_TOUCHCAST_PLAYER_ELEMENT + ''), constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY);
            }
            // if (util.isiPad() || util.isiPhone() || util.isiPod())
            //     core.addClass(videoNode, constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY);
            if (!options.isHls()) {
                if (util.readCookie('TC' + video.id) && options.getCacheSkip() === 0) {
                    mp4VideoSrc += '?r=' + new Date().getTime();
                }

                core.setAttr(videoNode, 'data-poster', video.thumb_url);
                core.setAttr(videoNode, 'poster', video.thumb_url);
            }
            if (util.isiPad() && options.getTcVideoType() === 'note') {
                posterImgNode = core.init('<img class="' + constants.CSS_TOUCHCAST_POSTER_IMAGE + '" alt="poster" src="' + video.thumb_url + '" />');
                core.setCss(videoNode, {
                    marginLeft: '10.9%'
                });
            }
            if (webmVideoSrcNode)
                core.append(videoNode, webmVideoSrcNode);
            if (!options.isHls()) {
                core.setAttr(mp4VideoSrcNode, 'src', mp4VideoSrc);
                core.append(videoNode, mp4VideoSrcNode);
            } else if (!options.isHlsSupported()) {
                logger.log('appending source node if not live');
                core.setAttr(mp4VideoSrcNode, 'src', mp4VideoSrc);
                core.append(videoNode, mp4VideoSrcNode);
            }
            core.append(options.elem, posterWithPlayBtn);
            if (posterImgNode)
                core.append(options.elem, posterImgNode);
            core.append(options.elem, videoWrapper);
            core.append(videoWrapper, videoWrapperHeightAligner);
            core.append(videoWrapperHeightAligner, videoNode);


            this.initHoverActive();
            /*core.on(core.init('.' + constants.CSS_TOUCHCAST_STOP_PROPAGATION + ', #tcEndChannel, .top_bar, .tcPlayerHeader'), 'touchstart click', function(e) {
                if (core.hasClass(core.init(e.target), constants.CSS_TOUCHCAST_HOVER_ACTIVE))
                    return true;
                e.preventDefault();
                e.stopImmediatePropagation();
            });*/
            if (options.isHls()) {
                core.after(videoNode, '<canvas class="' + constants.CSS_TOUCHCAST_HLS_CANVAS + '" id="' + constants.CSS_TOUCHCAST_HLS_CANVAS + '" width="100%" height="100%" style="position: absolute; z-index:-2; visibility:hidden"></canvas>');
            }
            if ((util.isiPhone() || util.isiPod()) && !util.checkIfInlinePlaySupported()) {
                options.setiPhonePlay(true);
                var videoEle = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '');
                core.hide(videoEle);
                core.setAttr(videoEle, 'muted', true);
                core.after(videoEle, '<canvas class="' + constants.CSS_TOUCHCAST_IPHONE_CANVAS + '" id="' + constants.CSS_TOUCHCAST_IPHONE_CANVAS + '" height="auto " width="100%" ></canvas>');
                if (typeof video.mp3Url !== 'undefined' && video.mp3Url !== '') {
                    logger.log('Mp3 Url if present', video.mp3Url);
                    options.setAudio(new Audio(video.mp3Url));
                } else {
                    //context = new(window.AudioContext || window.webkitAudioContext)();
                    var audio = new Audio();
                    audio.crossOrigin = "anonymous";
                    /*this.source = context.createMediaElementSource(audio);
                    this.filter = context.createBiquadFilter();
                    this.filter.type = this.filter.LOWPASS;
                    this.filter.frequency.value = 44100;
                    // Connect the audio graph.
                    this.source.connect(this.filter);
                    this.filter.connect(context.destination);*/
                    if (options.isHls()) {
                        audio.src = video;
                    } else {
                        audio.src = video.video_url;
                    }
                    options.setAudio(audio);

                }
            }
            // set empty sound
            options.setSound(new Audio());
            options.setSoundIsEmpty(true);

        },
        buildFlashUI: function(video) {
            core.addClass(core.init('.' + constants.CSS_TOUCHCAST_MAIN_CONTAINER + ''), constants.CSS_TOUCHCAST_FLASH_PLAYER);
            this.showLoading();
            this.showControls();
            if (options.getInteractiveTip() === true) {
                core.fadeIn(core.init('.' + constants.CSS_TOUCHCAST_TAP_OR_CLICK_CONTAINER + ''), 'fast');
            }
            var posterWithPlayBtn = this.getPoster();
            core.setCss(posterWithPlayBtn, {
                height: (Math.ceil((core.getWidth(options.elem) * 9) / 16)) + 'px',
                'background-image': 'url(' + video.thumb_url + ')'
            });

            var flashContainer = core.init('<div id="' + constants.CSS_TOUCHCAST_FLASH_VIDEO_CONTAINER + '"></div>');
            core.addClass(flashContainer, constants.CSS_TOUCHCAST_FIT_SCREEN);

            var getPlayerLink = core.init('<a href="http://www.adobe.com/go/getflashplayer" target="_blank"></a>');
            var getPlayerImg = core.init('<img alt="Get Adobe Flash Player" />');
            core.setAttr(getPlayerImg, 'src', options.getFlashPlayerImg());
            core.append(getPlayerLink, getPlayerImg);
            var noFlashPlugin = core.init('<div></div>');
            var noFlashPluginMsg = 'It looks like you don\'t have the Adobe Flash Player plugin installed. Please install the plugin by clicking the button below, or simply make sure you are using the latest version of your browser.';
            noFlashPlugin.html(noFlashPluginMsg + '<br /><br />');
            core.addClass(noFlashPlugin, constants.CSS_TOUCHCAST_NO_FLASH_PLUGIN);
            core.addClass(noFlashPlugin, constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY);
            core.addClass(noFlashPlugin, constants.CSS_TOUCHCAST_FIT_SCREEN);
            core.append(noFlashPlugin, getPlayerLink);

            var flashVar = TouchCast.InteractiveLayer.getFlashFallback(video.video_url) + '&performanceID=' + video.id;
            var flashObject = core.init('<object name="' + constants.CSS_TOUCHCAST_FLASH_VIDEO_ELEMENT_NAME + '" id="' + constants.CSS_TOUCHCAST_FLASH_VIDEO_ELEMENT + '" class="' + constants.CSS_TOUCHCAST_FLASH_VIDEO_ELEMENT_NAME + ' ' + constants.CSS_TOUCHCAST_FIT_SCREEN + '" data="' + flashVar + '" type="application/x-shockwave-flash" wmode="transparent" allowfullscreen="true" allowscriptaccess="always" width="100%" height="100%"><param name="wmode" value="transparent"><param name="allowscriptaccess" value="always"><param name="movie" value="' + flashVar + '"></object>');
            core.append(flashObject, noFlashPlugin);
            core.append(flashContainer, flashObject);

            core.append(options.elem, posterWithPlayBtn);
            core.append(options.elem, '<div id="' + constants.CSS_TOUCHCAST_FLASH_OVERLAY + '" class="' + constants.CSS_TOUCHCAST_FLASH_OVERLAY + '"></div>');
            core.append(options.elem, flashContainer);
            this.initHoverActive();
        },
        // _resizeProgressBar: function() {
        //     core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_PANEL).width(core.init('.' + constants.CSS_TOUCHCAST_CONTROLS).width() - core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_PANEL).offset().left - core.init('.' + constants.CSS_TOUCHCAST_CONTROL_RIGHT_CONTAINER + '').width());
        // },
        _resizeSearch: function() {
            var searchWrapper = core.init('.' + constants.CSS_TOUCHCAST_WRAPPER_SEARCH);
            if (searchWrapper.length > 0) {
                var searchWrapperWidth = searchWrapper.width();
                var searchWrapperOffsetLeft = searchWrapper.offset().left;
                var searchWrapperOffsetTop = searchWrapper.offset().top;
                var searchIcon = core.init('.' + constants.CSS_TOUCHCAST_ICON_SEARCH);
                var searchCloseIcon = core.init('.' + constants.CSS_TOUCHCAST_ICON_SEARCH_CLOSE);
                var left = ((core.getWindowWidth() - (70 * core.getWindowWidth()) / 100) / 2) + searchWrapperWidth + 10;
                var leftSearch = core.getWindowWidth() - 64;
                var top = ((core.getWindowHeight() - (86 * core.getWindowHeight()) / 100) / 2) - 36;
                core.setCss(searchIcon, {
                    left: leftSearch + 'px',
                    top: top + 'px'
                });
                core.setCss(searchCloseIcon, {
                    left: left + 'px',
                    top: top + 'px'
                });
            }

            //core.init('.' + constants.CSS_TOUCHCAST_CHAT_WRAPPER).width(core.init('.' + constants.CSS_TOUCHCAST_CONTROLS).width() - core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_PANEL).offset().left - core.init('.' + constants.CSS_TOUCHCAST_CONTROL_RIGHT_CONTAINER + '').width());
            //core.init('.' + constants.CSS_TOUCHCAST_CHAT_WRAPPER).width(core.init('.' + constants.CSS_TOUCHCAST_CONTROLS).width() - core.init('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON).width() - (core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_DIVIDER).width()) - core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME).width() - core.init('.' + constants.CSS_TOUCHCAST_CONTROL_RIGHT_CONTAINER + '').width());
        },
        _resize: function () {
            if (options.isiPhonePlay()) {
                var mainContainer = core.init('.' + constants.CSS_TOUCHCAST_MAIN_CONTAINER + '');
                var videoW = core.getWidth(mainContainer);
                var videoH = core.getHeight(mainContainer) - core.getHeight(core.init('.' + constants.CSS_TOUCHCAST_CONTROLS + '')) - core.getHeight(core.init('body header'));
                if (videoW / videoH > 16 / 9) {
                    videoW = 16 / 9 * videoH;
                } else {
                    videoH = 9 / 16 * videoW;
                }
                var iPhoneCanvasWidth = videoW * util.getDevicePixelRatio();
                var iPhoneCanvasHeight = videoH  * util.getDevicePixelRatio();
                var iPhoneCanvas = core.init('#' + constants.CSS_TOUCHCAST_IPHONE_CANVAS + '');
                iPhoneCanvas.width(videoW).height(videoH);
                core.setAttr(iPhoneCanvas, 'width', iPhoneCanvasWidth);
                core.setAttr(iPhoneCanvas, 'height', iPhoneCanvasHeight);
                // core.addClass(iPhoneCanvas, 'alignMiddleXY');
            }
            if (options.isHls()) {
                var HlsCanvas = core.init('#' + constants.CSS_TOUCHCAST_HLS_CANVAS + '');
                HlsCanvas.width(options.getHlsLevelWidth()).height(options.getHlsLevelHeight());
                core.setAttr(HlsCanvas, 'width', options.getHlsLevelWidth());
                core.setAttr(HlsCanvas, 'height', options.getHlsLevelHeight());
                // core.addClass(HlsCanvas, 'alignMiddleXY');
            }

            if (share)
                share.resizeInput();

            if (settings)
                settings.resize(this);

            this._resizeSearch();

            return;
        },
        _updateTooltipster: function(btn, caption) {
            core.setAttr(btn, 'title', caption);
            core.setAttr(btn, 'data-original-title', caption);
            try {
              setTimeout(function(){
                  core.tooltipster(btn, 'content', caption);
              }, 3000)
            } catch (err) {
                //console.error(err);
            }
        },
        updatePlayPauseButton: function(btn, change) {
            var btnAddClass, btnRemoveClass = caption = '';
            if (change === 'play') {
                btnAddClass = constants.CSS_TOUCHCAST_PLAYER_PAUSE_BUTTON;
                btnRemoveClass = constants.CSS_TOUCHCAST_PLAYER_PLAY_BUTTON;
                caption = language.getPauseTooltip();
            } else {
                btnAddClass = constants.CSS_TOUCHCAST_PLAYER_PLAY_BUTTON;
                btnRemoveClass = constants.CSS_TOUCHCAST_PLAYER_PAUSE_BUTTON;
                caption = language.getPlayTooltip();
            }
            core.addClass(btn, btnAddClass);
            core.removeClass(btn, btnRemoveClass);
            this._updateTooltipster(btn, caption);
        },
        showHidePoster: function(ele, show) {
            var posterDataUrl = core.getAttr(core.init('#' + ele), 'data-poster');
            core.setAttr(core.init('#' + ele), show ? posterDataUrl : '');
            if (util.isiPad() && options.getTcVideoType() === 'note')
                core.hide(core.init('.' + constants.CSS_TOUCHCAST_POSTER_IMAGE + ''));
        },
        showControlButton: function(btn, dividerPosition) {
            btn = core.init(btn);
            var divider = '.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_DIVIDER + '';
            core.show(btn);
            if (dividerPosition = 'next')
                core.show(btn.next(divider));
            else if (dividerPosition = 'prev')
                core.show(btn.prev(divider));
            // this._resizeProgressBar();
        },
        hideControlButton: function(btn, dividerPosition) {
            btn = core.init(btn);
            var divider = '.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_DIVIDER + '';
            core.hide(btn);
            if (dividerPosition = 'next')
                core.hide(btn.next(divider));
            else if (dividerPosition = 'prev')
                core.hide(btn.prev(divider));
            // this._resizeProgressBar();
        },
        hideFullScreenButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_FULLSCREEN_BUTTON + '', 'prev');
        },
        hideProgressBar: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_PROGRESS_PANEL + '');
        },
        hideTimecode: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_TIMECODE + '', 'prev');
        },
        hidePlayButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_PLAY_PAUSE_BUTTON + '', 'next');
        },
        hideVolumeButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_VOLUME_CONTAINER + '');
        },
        hideInfoButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_INFO + '', 'next');
        },
        showInfoButton: function() {
            this.showControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_INFO + '', 'next');
        },
        hideCommentButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + '', 'next');
        },
        showCommentButton: function() {
            this.showControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_COMMENT + '', 'next');
        },
        hideSettingsButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SETTINGS + '', 'next');
        },
        showSettingsButton: function() {
            this.showControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SETTINGS + '', 'next');
        },
        hideTranscriptButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_TRANSCRIPTIONS + '', 'next');
        },
        showTranscriptButton: function() {
            this.showControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_TRANSCRIPTIONS + '', 'next');
        },
        hideRecastButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + '', 'next');
        },
        hideShareButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SHARE + '', 'next');
        },
        showRecastButton: function() {
            this.showControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_RECAST + '', 'next');
        },
        showShareButton: function() {
            this.showControlButton('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SHARE + '', 'next');
        },
        hideInfoBoxCounters: function() {
            core.hide(core.init('.' + constants.CSS_TOUCHCAST_INFO_PANEL_COUNTS_WRAPPER + ''));
        },
        hideInfoBoxBookmarkButton: function() {
            core.hide(core.init('.' + constants.CSS_TOUCHCAST_BOOKMARK_BUTTON + ''));
        },
        hideInfoBoxFollowButton: function() {
            core.hide(core.init('.' + constants.CSS_TOUCHCAST_FOLLOW_BUTTON + ''));
            core.setCss(core.init('.' + constants.CSS_TOUCHCAST_AVATAR_CONTAINER + ''), {
                marginTop: '20px'
            });
        },
        hideInfoBoxFlagButton: function() {
            core.hide(core.init('.' + constants.CSS_TOUCHCAST_FLAG_BUTTON + ''));
        },
        hideChatButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_CHAT_ICON + '', 'next');
            var chatInput = core.init('.' + constants.CSS_TOUCHCAST_CHAT_INPUT_WRAPPER + '');
            var chatContainer = core.init('.' + constants.CSS_TOUCHCAST_CHAT_WRAPPER + '');
            var userChat = core.init('.' + constants.CSS_TOUCHCAST_USER_CHAT + '');
            core.addClass(chatInput, constants.CSS_TOUCHCAST_HIDE);
            core.addClass(chatContainer, constants.CSS_TOUCHCAST_HIDE);
            core.setCss(userChat, {
                'opacity': '0'
            });
        },
        showChatButton: function() {
            this.showControlButton('.' + constants.CSS_TOUCHCAST_CHAT_ICON + '', 'next');
            var chatInput = core.init('.' + constants.CSS_TOUCHCAST_CHAT_INPUT_WRAPPER + '');
            var chatContainer = core.init('.' + constants.CSS_TOUCHCAST_CHAT_WRAPPER + '');
            var chatPostIcon = core.init('.' + constants.CSS_TOUCHCAST_CHAT_ICON + '');
            core.removeClass(chatInput, constants.CSS_TOUCHCAST_HIDE);
            core.removeClass(chatContainer, constants.CSS_TOUCHCAST_HIDE);
            core.addClass(chatPostIcon, constants.CSS_TOUCHCAST_SELECTED);
        },
        hideThumbsButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_THUMBS_ICON + '', 'next');
        },
        showThumbsButton: function() {
            this.showControlButton('.' + constants.CSS_TOUCHCAST_THUMBS_ICON + '', 'next');
        },
        hideLiveButton: function() {
            this.hideControlButton('.' + constants.CSS_TOUCHCAST_LIVE_ICON + '', 'next');
        },
        showLiveButton: function() {
            this.showControlButton('.' + constants.CSS_TOUCHCAST_LIVE_ICON + '', 'next');
        },
        hideInfoBoxBookmarkButton: function() {
            core.hide(core.init('.' + constants.CSS_TOUCHCAST_BOOKMARK_BUTTON + ''));
        },
        updateProgressPanelLeft: function(value) {
            core.setCss(core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_PANEL + ''), {
                marginLeft: value + 'px'
            });
        },
        updateVolumeContainerLeft: function(value) {
            core.setCss(core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTAINER + ''), {
                marginLeft: value + 'px'
            });
        },
        updateRecastContainerRight: function(value) {
            core.setCss(core.init('.' + constants.CSS_TOUCHCAST_CONTROL_RECAST_CONTAINER + ''), {
                right: value + 'px'
            });
        },
        showTrackGuide: function(positionPercent, time) {
            var ele = core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_TRACK_GUIDE + ', .' + constants.CSS_TOUCHCAST_PROGRESS_TRACK_CODE_GUIDE + '');
            core.setCss(ele, {
                left: positionPercent + '%'
            });
            core.show(ele);
            core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_TRACK_CODE_GUIDE + '').html(time);
        },
        hideTrackGuide: function() {
            core.hide(core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_TRACK_GUIDE + ', .' + constants.CSS_TOUCHCAST_PROGRESS_TRACK_CODE_GUIDE + ''));
        },
        isMute: function() {
            return core.hasClass(core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTAINER + ' .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME + ''), constants.CSS_TOUCHCAST_MUTE);
        },
        updateVolumeLabel: function(mute) {
            var caption = mute ? language.getVolumeUnmuteTooltip() : language.getVolumeMuteTooltip();
            var volObj = core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTAINER + ' .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME + '');
            if (mute) {
                core.addClass(volObj, constants.CSS_TOUCHCAST_MUTE);
                var bars = core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTROL + ' span');
                core.removeClass(bars, constants.CSS_TOUCHCAST_ACTIVE);
                core.removeClass(bars, constants.CSS_TOUCHCAST_MOUSE_ACTIVE);
            } else
                core.removeClass(volObj, constants.CSS_TOUCHCAST_MUTE);
            this._updateTooltipster(volObj, caption);
        },
        updateVolume: function(value, unmute) {
            var initVolumeBar = parseInt(value) - 1;
            this.setVolumeLabelValue(value);
            var bar = core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTROL + ' span:eq(' + initVolumeBar + ')');
            core.removeClass(core.nextAll(bar, 'span'), constants.CSS_TOUCHCAST_ACTIVE);
            core.addClass(core.prevAll(bar, 'span'), constants.CSS_TOUCHCAST_ACTIVE);
            if (!this.isMute()) {
                core.addClass(bar, constants.CSS_TOUCHCAST_ACTIVE);
            }
            if (this.isMute() && unmute === true)
                this.updateVolumeLabel(false);
            else
                this.updateVolumeLabel(this.isMute());
            return bar;
        },
        updateVolumeBarOnMouseActive: function(bar) {
            core.removeClass(core.prevAll(bar, 'span'), constants.CSS_TOUCHCAST_MOUSE_ACTIVE);
            core.removeClass(core.nextAll(bar, 'span'), constants.CSS_TOUCHCAST_MOUSE_ACTIVE);
            core.addClass(bar, constants.CSS_TOUCHCAST_MOUSE_ACTIVE);
        },
        setVolumeLabelValue: function(value) {
            core.init('.' + constants.CSS_TOUCHCAST_VOLUME_LABEL + '').html(value);
        },
        initVolumeControl: function() {
            var self = this;
            var volumeTimer = '';
            this.updateVolume(options.getVolume());

            var volControl = core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTAINER + ' .' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_VOLUME + ', .' + constants.CSS_TOUCHCAST_VOLUME_CONTROL + '');
            core.off(volControl, 'mouseover');
            core.on(volControl, 'mouseover', function() {
                if (!core.hasClass(core.init(this), constants.CSS_TOUCHCAST_VOLUME_CONTROL)) {
                    if (self.isMute())
                        return false;
                    var curVolume = options.getVolume();
                    var bar = self.updateVolume(curVolume);
                    self.updateVolumeBarOnMouseActive(bar);
                }
            });

            var obj = core.init('.' + constants.CSS_TOUCHCAST_VOLUME_CONTROL + ' span');
            core.off(obj, 'mouseover');
            core.on(obj, 'mouseover', function(e) {
                e.stopImmediatePropagation();
                var bar = self.updateVolume(core.init(this).index() + 1);
                self.updateVolumeBarOnMouseActive(bar);
            });
        },
        toggleFullscreen: function(btn) {
            var mainContainer = core.init('.' + constants.CSS_TOUCHCAST_MAIN_WRAPPER + '').parent()[0];
            var caption = language.getFullscreenTooltip();
            if (options.isFullscreen() === 0) {
                if (mainContainer.requestFullscreen) {
                    mainContainer.requestFullscreen();
                } else if (mainContainer.mozRequestFullScreen) {
                    mainContainer.mozRequestFullScreen();
                } else if (mainContainer.webkitRequestFullscreen) {
                    mainContainer.webkitRequestFullscreen();
                } else if (mainContainer.msRequestFullscreen) {
                    mainContainer.msRequestFullscreen();
                }
                options.setFullscreen(1);
                caption = language.getFullscreenExitTooltip();
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                }
                options.setFullscreen(0);
            }
            this._updateTooltipster(btn, caption);
        },
        clearControlSelections: function() {
            if (recast)
                recast.hideRecastPopup();
            var shareBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SHARE + '');
            var sharePanel = core.init('.' + constants.CSS_TOUCHCAST_SHARE_PANEL + '');
            share.hideSharePopup(shareBtn, sharePanel);
            var infoBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_INFO + '');
            var infoPanel = core.init('.' + constants.CSS_TOUCHCAST_INFO_PANEL + '');
            this.hideInfoPanel(infoBtn, infoPanel);
            if (comment) {
                var commentsWrapper = core.init('.' + constants.CSS_TOUCHCAST_COMMENTS_WRAPPER + '');
                comment.hideCommentsPopup(commentsWrapper);
            }
        },
        getVappsIconColor: function(vappInfo) {
            var color = 'tcVappRed';
            var urlPattern = new RegExp('touchcast\:\/\/');
            if (urlPattern.test(vappInfo['url'])) { // TC inside
                color = 'tcVappWhite';
            } else if (vappInfo['type'] === 'vApp') { // Overlay
                color = 'tcVappRed';
            } else {
                if (vappInfo['type'] === 'html')
                    color = 'tcVappBlue';
                else if (vappInfo['type'] === 'video')
                    color = 'tcVappGreen';
                else if (vappInfo['type'] === 'image')
                    color = 'tcVappGrey';
            }
            return color;
        },
        getKeyPoint: function(pos, thumb, color) {
            var vappThumbImg = core.init('<img alt="" />');
            //var thumb = decodeURIComponent(thumb);
            core.setAttr(vappThumbImg, 'src', thumb.replace('http://', 'https://'));
            core.addClass(vappThumbImg, constants.CSS_TOUCHCAST_HIDE);
            core.addClass(vappThumbImg, constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY);
            var vappThumbWrapper = core.init('<span></span>');
            var vappThumbContainer = core.init('<span></span>');
            var vappIconContainer = core.init('<a href="#"></a>');
            var vappIcon = core.init('<span></span>');
            var vappPreviewLine = core.init('<b></b>');

            core.addClass(vappThumbContainer, constants.CSS_TOUCHCAST_VAPP_PREVIEW_CONTAINER);
            core.addClass(vappThumbContainer, constants.CSS_TOUCHCAST_HIDE);
            core.addClass(vappThumbContainer, color);
            core.addClass(vappThumbWrapper, constants.CSS_TOUCHCAST_VAPP_PREVIEW_WRAPPER);
            core.addClass(vappThumbWrapper, constants.CSS_TOUCHCAST_ALIGN_MIDDLE_XY);
            core.append(vappThumbWrapper, vappThumbImg);
            core.append(vappThumbContainer, vappThumbWrapper);
            core.append(vappThumbContainer, loadingVapp);

            core.addClass(vappIconContainer, constants.CSS_TOUCHCAST_VAPP_ICONS);
            core.addClass(vappIconContainer, color);
            core.setCss(vappIconContainer, {
                'left': pos + '%'
            });

            core.addClass(vappIcon, constants.CSS_TOUCHCAST_VAPP_ICON);
            core.append(vappIconContainer, vappIcon);
            core.append(vappIconContainer, vappThumbContainer);

            core.addClass(vappPreviewLine, color);
            core.addClass(vappPreviewLine, constants.CSS_TOUCHCAST_HIDE);
            core.append(vappIconContainer, vappPreviewLine);
            return vappIconContainer;
        },
        addKeyPoints: function(vappsInfo) {
            logger.log('Total duration ', options.getTotalDuration());
            var data = videoInfoData = vappsInfo;
            for (i in videoInfoData) {
                var videoDuration = parseFloat(videoInfoData[i]['duration']);
                logger.log('Current video duration (chaptering support) ', videoDuration);
                var percentage = (videoDuration / options.getTotalDuration()) * 100;
                var videoListNode = core.init('<div class="' + constants.CSS_TOUCHCAST_VIDEO_LIST_ITEM + ' ' + constants.CSS_TOUCHCAST_BG_TRANSITION + '"></div>');
                core.setCss(videoListNode, {
                    'width': percentage + '%'
                });

                var vapps = videoInfoData[i]['vApps'];
                for (n in vapps) {
                    var vappPercentage = (parseFloat(vapps[n]['open_time']) / options.getTotalDuration()) * 100;
                    if (parseFloat(vappPercentage) < 0.5) {
                        vappPercentage = 0.5;
                    }
                    var color = this.getVappsIconColor(vapps[n]);
                    var thumb = vapps[n]['thumb_url'];
                    if (typeof thumb === 'undefined' || thumb === '' || !thumb) {
                        var thumb = 'data:image/png;base64,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';
                    }
                    core.append(videoListNode, this.getKeyPoint(vappPercentage, thumb, color));
                }
                core.append(core.init('.' + constants.CSS_TOUCHCAST_VIDEO_LIST_CONTAINER + ''), videoListNode);
            }
            this.initVappsIconEvents();
        },
        initVappsIconEvents: function() {
            var self = this;
            var vappsIcon = core.init('.' + constants.CSS_TOUCHCAST_VAPP_ICONS + '');
            core.off(vappsIcon, 'mouseenter mouseleave touchstart click');
            core.on(vappsIcon, 'mouseenter', function() {
                core.removeClass(vappsIcon, constants.CSS_TOUCHCAST_ACTIVE);
                core.addClass(core.init(this), constants.CSS_TOUCHCAST_ACTIVE);
                clearTimeout(options.vappCloseTimer);
                options.vappCloseTimer = null;
                var vappThumb = core.find(core.init(this), '.' + constants.CSS_TOUCHCAST_VAPP_PREVIEW_CONTAINER + ' img');
                if (core.hasClass(vappThumb, constants.CSS_TOUCHCAST_HIDE)) {
                    var img = new Image();
                    img.onerror = function() {
                        core.setAttr(vappThumb, 'src', 'data:image/png;base64,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');
                        core.fadeIn(vappThumb, 'fast');
                    };
                    img.onload = function() {
                        core.fadeIn(vappThumb, 'fast');
                    };
                    img.src = core.getAttr(vappThumb, 'src');
                }
            });
            core.on(vappsIcon, 'mouseleave', function() {
                core.removeClass(core.init(this), constants.CSS_TOUCHCAST_ACTIVE);
            });

            core.on(vappsIcon, 'touchstart', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                self.hideTrackGuide();
                var vappIcon = core.init(this);
                var evnt = util.getTouchEvent(e);
                core.trigger(vappIcon, 'mouseenter');
                core.trigger(vappIcon, 'mousemove');
                core.trigger(vappIcon, new core.Event('mousedown', evnt));
                core.trigger(vappIcon, new core.Event('mouseup', evnt));
                return false;
            });

            core.on(vappsIcon, 'mousedown mouseup', function(e) {
                var vappIcon = core.init(this);
                options.setUserActive(0);
                e.pageX = vappIcon.offset().left + ((vappIcon.width() * 1.5) / 2);
                core.trigger(core.init('.' + constants.CSS_TOUCHCAST_PROGRESS_TRACK + ''), e);
                self.showHidePoster(constants.CSS_TOUCHCAST_VIDEO_ELEMENT, 0);
                options.setUserActive(1);
                e.stopImmediatePropagation();
                return false;
            });
        },
        showTCInsideTCHeader: function(player) {
            core.remove(core.init('.' + constants.CSS_TOUCHCAST_PLAYER_HEADER + ''));
            var playerHeader = core.init('<div class="useSprite"></div>');
            core.addClass(playerHeader, constants.CSS_TOUCHCAST_PLAYER_HEADER);
            core.addClass(playerHeader, constants.CSS_TOUCHCAST_HOVER_ACTIVE);
            core.append(playerHeader, '<span class="' + constants.CSS_TOUCHCAST_BG_TRANSITION + ' squareIcon44 tcCustomBgHover"></span>' + language.getTcInsideTcTopLeftReturnText());
            core.prepend(core.init('.' + constants.CSS_TOUCHCAST_MAIN_CONTAINER + ''), playerHeader);
            playerHeader = core.init('.' + constants.CSS_TOUCHCAST_PLAYER_HEADER + '');
            core.off(playerHeader, 'touchstart click mouseenter mouseleave');
            core.on(playerHeader, 'mouseenter', function() {
                core.addClass(core.init(this), constants.CSS_TOUCHCAST_ACTIVE);
            });
            core.on(playerHeader, 'mouseleave', function() {
                core.removeClass(core.init(this), constants.CSS_TOUCHCAST_ACTIVE);
            });
            core.on(playerHeader, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                player.goBackToOriginal();
            });
            var i = 0;
            var blinkInterval = setInterval(function() {
                i++;
                if (i === 8)
                    clearInterval(blinkInterval);
                var playerHeaderIco = core.find(playerHeader, 'span');
                if (core.hasClass(playerHeaderIco, constants.CSS_TOUCHCAST_PLAYER_HEADER_HOVER))
                    core.removeClass(playerHeaderIco, constants.CSS_TOUCHCAST_PLAYER_HEADER_HOVER);
                else
                    core.addClass(playerHeaderIco, constants.CSS_TOUCHCAST_PLAYER_HEADER_HOVER);
            }, 400);
        },
        drawVideoFrame: function() {
            var vPlayer = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0];
            var iPhoneCanvas = core.init('#' + constants.CSS_TOUCHCAST_IPHONE_CANVAS + '')[0];
            if (util.isHighDensity()) {
                var wt = iPhoneCanvas.clientWidth * 2;
                var ht = iPhoneCanvas.clientHeight * 2;
            } else {
                var wt = iPhoneCanvas.clientWidth;
                var ht = iPhoneCanvas.clientHeight;
            }

            var ctx = iPhoneCanvas.getContext('2d');
            ctx.drawImage(vPlayer, 0, 0, wt, ht);
        },
        getLayoutValue: function() {
            var vPlayer = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0];
            var HlsCanvas = core.init('#' + constants.CSS_TOUCHCAST_HLS_CANVAS + '')[0];
            var wt = HlsCanvas.clientWidth;
            var ht = HlsCanvas.clientHeight;
            var ctx = HlsCanvas.getContext('2d');
            ctx.drawImage(vPlayer, 0, 0, wt, ht);
            var widthOfElement = wt / 32;
            var heightOfElement = wt / (32 * 8);
            var fullBinary = '';
            //var decimal = 0;
            for (i = 31; i >= 0; i--) {
                var xIMin = Math.ceil(wt - (i + 1) * widthOfElement);
                var xIMax = Math.floor(wt - i * widthOfElement);
                var yIMin = Math.ceil(ht - heightOfElement);
                var yIMax = ht;
                var p = ctx.getImageData((xIMin + xIMax) / 2, (yIMin + yIMax) / 2, 1, 1).data;
                var binary = util.getBinaryValue(p[0], p[1], p[2]);
                fullBinary = fullBinary + '' + binary;
            }
            var threeHighestBits = fullBinary.substring(0, 3);
            if (threeHighestBits !== '101') {
                return false;
            }
            var parityBit = fullBinary.substring(31, 32);
            var binaryName = fullBinary.substring(3, 31);
            var decimal = parseInt(binaryName, 2);
            var binaryWithParity = fullBinary.substring(3, 32);
            var numberOfOnes = binaryWithParity.toString(2).replace(/0/g, "").length;
            if (numberOfOnes % 2 !== 0) {
                return false;
            }
            if (decimal < 1) {
                return false;
            }
            var layoutName = decimal;
            return layoutName;

        },
        getDecimalHLS: function() {
            var vPlayer = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0];
            var HlsCanvas = core.init('#' + constants.CSS_TOUCHCAST_HLS_CANVAS + '')[0];
            var wt = HlsCanvas.clientWidth;
            var ht = HlsCanvas.clientHeight;
            var ctx = HlsCanvas.getContext('2d');
            ctx.drawImage(vPlayer, 0, 0, wt, ht);
            var squareSize = options.getHlsSquareSize();
            var decimal = 0;
            for (i = 0; i < options.getHlsSquareNumber(); i++) {
                var p = ctx.getImageData((i * squareSize) + ((squareSize) / 2), ht - (squareSize / 2), 1, 1).data;
                var binary = util.getBinaryValue(p[0], p[1], p[2]);
                decimal = decimal + (binary * Math.pow(2, i));
            }
            return decimal;
        },
        videoTick: function() {
            var self = this;
            var vPlayer = core.init('#' + constants.CSS_TOUCHCAST_VIDEO_ELEMENT + '')[0];
            var time = Date.now();
            var timeDiff = (time - options.getPrevTime()) / 1000;
            try {
                if (timeDiff >= (1 / 30)) {
                    self.drawVideoFrame();
                    vPlayer.currentTime = options.getAudio().currentTime;
                    options.setPrevTime(time);
                }
                if (vPlayer.currentTime >= vPlayer.duration)
                    options.setPlaying(false);
            } catch (err) {
                console.error(err);
            }
            if (options.isPlaying()) {
                options.animationFrame = requestAnimationFrame(function() {
                    self.videoTick();
                });
            } else {
                cancelAnimationFrame(options.animationFrame);
            }
        },
        showRedirectConfirmationPopup: function(msg, link) {
            var embedConfirmationWrapper = core.init('#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP + '.' + constants.CSS_TOUCHCAST_MODAL_BOX + '');
            var embedConfirmationBrowserList = core.find(embedConfirmationWrapper, '.' + constants.CSS_TOUCHCAST_EMBEDED_BROWSER_LIST + '');
            var embedConfirmationDesc = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_DESCRIPTION + '');
            var embedConfirmationTitle = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_TITLE + '');
            var embedConfirmationYesBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_YES_BUTTON + '');
            var embedConfirmationNoBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_NO_BUTTON + '');
            var embedConfirmationOkBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_OK_BUTTON + '');
            core.remove(embedConfirmationBrowserList);
            core.addClass(embedConfirmationWrapper, constants.CSS_TOUCHCAST_OPEN);
            core.html(embedConfirmationTitle, '');
            core.html(embedConfirmationDesc, msg);
            core.setAttr(embedConfirmationYesBtn, 'href', link);
            core.show(embedConfirmationYesBtn);
            core.show(embedConfirmationNoBtn);
            core.hide(embedConfirmationOkBtn);
        },
        showNonInteractivePopup: function(msg, title, link) {
            if (!msg) {
                var msg = 'You can watch this TouchCast live stream in this browser but to interact with the video we recommend switching to a modern, desktop browser such as:'
            }
            if (!title) {
                var title = 'Oops!'
            }
            var browserList = '<ul class="tcLiveBrowserList"><li>Safari (MacOS Sierra 10.12)</li><li>Chrome (MacOS and Win 7, 8 and 10)</li><li>Firefox (MacOS and Win 7, 8 and 10)</li><li>IE11 (Win 8 and 10)</li><li>Edge (Win 10)</li><ul>'
            var embedConfirmationWrapper = core.init('#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP + '.' + constants.CSS_TOUCHCAST_MODAL_BOX + '');
            var embedConfirmationBrowserList = core.find(embedConfirmationWrapper, '.' + constants.CSS_TOUCHCAST_EMBEDED_BROWSER_LIST + '');
            var embedConfirmationDesc = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_DESCRIPTION + '');
            var embedConfirmationTitle = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_TITLE + '');
            var embedConfirmationYesBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_YES_BUTTON + '');
            var embedConfirmationNoBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_NO_BUTTON + '');
            var embedConfirmationOkBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_OK_BUTTON + '');
            core.remove(embedConfirmationBrowserList);
            core.addClass(embedConfirmationWrapper, constants.CSS_TOUCHCAST_OPEN);
            core.html(embedConfirmationTitle, title);
            core.html(embedConfirmationDesc, msg);
            core.after(embedConfirmationDesc, browserList);
            core.hide(embedConfirmationYesBtn);
            core.hide(embedConfirmationNoBtn);
            core.show(embedConfirmationOkBtn);
        },
        showNotSupportedPopup: function(msg, title, link) {
            if (!msg) {
                var msg = 'We\'re sorry but this browser cannot support a TouchCast live stream. Please switch to a modern browser such as:';
            }
            if (!title) {
                var title = 'Oops!'
            }
            var browserList = '<ul class="tcLiveBrowserList"><li>Safari (MacOS Sierra 10.12)</li><li>Chrome (MacOS and Win 7, 8 and 10)</li><li>Firefox (MacOS and Win 7, 8 and 10)</li><li>IE11 (Win 8 and 10)</li><li>Edge (Win 10)</li><ul>'
            var embedConfirmationWrapper = core.init('#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP + '.' + constants.CSS_TOUCHCAST_MODAL_BOX + '');
            var embedConfirmationBrowserList = core.find(embedConfirmationWrapper, '.' + constants.CSS_TOUCHCAST_EMBEDED_BROWSER_LIST + '');
            var embedConfirmationDesc = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_DESCRIPTION + '');
            var embedConfirmationTitle = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_TITLE + '');
            var embedConfirmationYesBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_YES_BUTTON + '');
            var embedConfirmationNoBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_NO_BUTTON + '');
            var embedConfirmationOkBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_OK_BUTTON + '');
            core.remove(embedConfirmationBrowserList);
            core.addClass(embedConfirmationWrapper, constants.CSS_TOUCHCAST_OPEN);
            core.html(embedConfirmationTitle, title);
            core.html(embedConfirmationDesc, msg);
            core.after(embedConfirmationDesc, browserList);
            core.hide(embedConfirmationYesBtn);
            core.hide(embedConfirmationNoBtn);
            core.show(embedConfirmationOkBtn);
        },
        showNonOptimizedPopup: function(msg, link) {
            if (!msg) {
                var msg = 'Please enjoy this non-optimized playback of the TouchCast live stream while we convert the stream into a touchcast video.';
            }
            var embedConfirmationWrapper = core.init('#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP + '.' + constants.CSS_TOUCHCAST_MODAL_BOX + '');
            var embedConfirmationBrowserList = core.find(embedConfirmationWrapper, '.' + constants.CSS_TOUCHCAST_EMBEDED_BROWSER_LIST + '');
            var embedConfirmationDesc = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_DESCRIPTION + '');
            var embedConfirmationTitle = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_TITLE + '');
            var embedConfirmationYesBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_YES_BUTTON + '');
            var embedConfirmationNoBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_NO_BUTTON + '');
            var embedConfirmationOkBtn = core.find(embedConfirmationWrapper, '#' + constants.CSS_TOUCHCAST_EMBEDED_CONFIRMATION_POPUP_OK_BUTTON + '');
            core.remove(embedConfirmationBrowserList);
            core.addClass(embedConfirmationWrapper, constants.CSS_TOUCHCAST_OPEN);
            core.html(embedConfirmationDesc, msg);
            core.html(embedConfirmationTitle, '');
            core.hide(embedConfirmationYesBtn);
            core.hide(embedConfirmationNoBtn);
            core.show(embedConfirmationOkBtn);
        },
        showLoginForm: function() {
            var loginLink = core.init('span.' + constants.CSS_TOUCHCAST_LOGIN_LINK + '');
            if (loginLink.length > 0)
                core.trigger(loginLink, 'click');
        },
        preChecksForAjaxCall: function(msg, link) {
            var self = this;
            if (options.getApiUrl() === '' || !options.getApiUrl()) {
                if (options.getUser()) {
                    if (options.getUser() !== null || options.getUser().getUserId() === '') {
                        var venoBoxIframe = core.init('iframe.' + constants.CSS_TOUCHCAST_VENOBOX_FRAME + '');
                        if (venoBoxIframe.contents().context.body.className === 'embeded') {
                            self.showRedirectConfirmationPopup(msg, link);
                            return false;
                        }
                        if (options.isLoggedIn())
                            return true;
                        else {
                            self.showLoginForm();
                        }
                    } else {
                        self.showRedirectConfirmationPopup(msg, link);
                    }
                } else {
                    self.showRedirectConfirmationPopup(msg, link);
                }
                return false;
            } else {
                if (options.getApiSession() && options.getApiSession() !== null && options.getApiSession() !== '') {
                    return true;
                } else {
                    self.showRedirectConfirmationPopup(msg, link);
                    return false;
                }

                return false;
            }
        },
        initBookmark: function(video, isAjaxAllowed) {
            var self = this;
            var bookmarkBtn = core.init('.' + constants.CSS_TOUCHCAST_BOOKMARK_BUTTON + '');
            core.off(bookmarkBtn, 'touchstart click');
            core.on(bookmarkBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var btn = core.init(this);
                var msg = options.getBookmarkRedirectConfirmationMsg();
                if (core.hasClass(btn, constants.CSS_TOUCHCAST_BOOKMARKED))
                    msg = options.getUnbookmarkRedirectConfirmationMsg();
                if (self.preChecksForAjaxCall(msg, video.url)) {
                    if (!isAjaxAllowed || core.hasClass(btn, constants.CSS_TOUCHCAST_DISABLE))
                        return false;

                    core.addClass(btn, constants.CSS_TOUCHCAST_DISABLE);
                    if (core.hasClass(btn, constants.CSS_TOUCHCAST_BOOKMARKED))
                        loadData.bookmarkPerformance(video.id, function(data) {
                            core.removeClass(btn, constants.CSS_TOUCHCAST_DISABLE);
                            if (data && data.success.msg === 'Success') {
                                core.removeClass(btn, constants.CSS_TOUCHCAST_BOOKMARKED);
                                self._updateTooltipster(btn, language.getInfoBoxBookmarkTooltip());
                            }
                        }, 1);
                    else
                        loadData.bookmarkPerformance(video.id, function(data) {
                            core.removeClass(btn, constants.CSS_TOUCHCAST_DISABLE);
                            if (data && data.success.msg === 'Success') {
                                core.addClass(btn, constants.CSS_TOUCHCAST_BOOKMARKED);
                                self._updateTooltipster(btn, language.getInfoBoxRemoveBookmarkTooltip());
                            }
                        }, 0);
                }
                return false;
            });
        },
        initFollow: function(video, isAjaxAllowed) {
            var self = this;
            var followBtn = core.init('.' + constants.CSS_TOUCHCAST_FOLLOW_BUTTON + '');
            core.off(followBtn, 'touchstart click');
            core.on(followBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                var btn = core.init(this);
                var msg = options.getFollowRedirectConfirmationMsg();
                if (core.hasClass(btn, constants.CSS_TOUCHCAST_SUBSCRIBED))
                    msg = options.getUnfollowRedirectConfirmationMsg();
                if (self.preChecksForAjaxCall(msg, video.url)) {
                    if (!isAjaxAllowed || core.hasClass(btn, constants.CSS_TOUCHCAST_DISABLE))
                        return false;

                    core.addClass(btn, constants.CSS_TOUCHCAST_DISABLE);
                    if (core.hasClass(btn, constants.CSS_TOUCHCAST_SUBSCRIBED))
                        loadData.followChannel(video.user.user_id, function(data) {
                            core.removeClass(btn, constants.CSS_TOUCHCAST_DISABLE);
                            if (data && data.success.msg === 'Success') {
                                core.removeClass(btn, constants.CSS_TOUCHCAST_SUBSCRIBED);
                                self._updateTooltipster(btn, language.getInfoBoxFollowTooltip());
                                core.html(btn, language.getInfoBoxFollowText());
                            }
                        }, 1);
                    else
                        loadData.followChannel(video.user.user_id, function(data) {
                            core.removeClass(btn, constants.CSS_TOUCHCAST_DISABLE);
                            if (data && data.success.msg === 'Success') {
                                core.addClass(btn, constants.CSS_TOUCHCAST_SUBSCRIBED);
                                self._updateTooltipster(btn, language.getInfoBoxUnfollowTooltip());
                                core.html(btn, language.getInfoBoxUnfollowText());
                            }
                        }, 0);
                }
                return false;
            });
        },
        initReCast: function(isAjaxAllowed) {
            recast.init(this, isAjaxAllowed);
            this.recastInited = 1;
        },
        initInfoPanel: function(video, isAjaxAllowed) {
            var self = this;
            var infoBtn = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_INFO + '');
            var infoPanel = core.init('.' + constants.CSS_TOUCHCAST_INFO_PANEL + '');
            core.removeClass(infoPanel, constants.CSS_TOUCHCAST_HIDE);
            if (util.getIEVersion() === 8) {
                setTimeout(function() {
                    core.removeClass(infoBtn, 'icon-info-circled');
                    core.addClass(infoBtn, 'icon-info-circled');
                }, 500);
            }
            core.off(infoBtn, 'touchstart click');
            core.on(infoBtn, 'touchstart click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (core.hasClass(infoPanel, constants.CSS_TOUCHCAST_PANEL_SLIDE_DOWN)) {
                    self.showInfoPanel(infoBtn, infoPanel);
                } else {
                    self.hideInfoPanel(infoBtn, infoPanel);
                }
            });
            this.setPlayerLanguageForInfoModule();
            flag.initFlag(video, isAjaxAllowed);
            this.initModal();
            this.initBookmark(video, isAjaxAllowed);
            this.initFollow(video, isAjaxAllowed);
        },
        showInfoPanel: function(infoBtn, infoPanel) {
            this.clearControlSelections();
            core.addClass(infoBtn, constants.CSS_TOUCHCAST_SELECTED);
            core.removeClass(infoPanel, constants.CSS_TOUCHCAST_PANEL_SLIDE_DOWN);
            core.tooltipster(infoBtn, 'disable');
        },
        hideInfoPanel: function(infoBtn, infoPanel) {
            core.removeClass(infoBtn, constants.CSS_TOUCHCAST_SELECTED);
            core.addClass(infoPanel, constants.CSS_TOUCHCAST_PANEL_SLIDE_DOWN);
            core.tooltipster(infoBtn, 'enable');
        },
        updateInfoPanel: function(video, isAjaxAllowed, player) {
            var self = this;
            core.init('.' + constants.CSS_TOUCHCAST_VIDEO_TITLE + '').html(video.name);
            core.init('.' + constants.CSS_TOUCHCAST_VIDEO_CHANNEL + '').html(video['user'].channel_name);
            var infoNoDesc = core.init('.' + constants.CSS_TOUCHCAST_VIDEO_DESC + ' .' + constants.CSS_TOUCHCAST_NO_VIDEO_DESC + '');
            var infoNoDescNode = core.init('<span></span>');
            core.addClass(infoNoDescNode, constants.CSS_TOUCHCAST_NO_VIDEO_DESC);
            core.addClass(infoNoDescNode, constants.CSS_TOUCHCAST_HIDE);
            infoNoDescNode.html(infoNoDesc.html());
            if (video.description !== '') {
                infoNoDesc.parent().html(video.description);
            } else {
                infoNoDesc.parent().html(language.getInfoBoxUserDescText());
                core.removeClass(infoNoDesc, constants.CSS_TOUCHCAST_HIDE);
            }
            core.append(infoNoDesc.parent(), infoNoDescNode);
            var avatar = core.init('.' + constants.CSS_TOUCHCAST_AVATAR_CONTAINER + ' .' + constants.CSS_TOUCHCAST_AVATAR + '');

            // dont set if follow button is hidden
            if (player.getInfoBoxFlagButtonState() !== 0) {
                core.setAttr(avatar, 'href', video['user'].channel_url);
            } else {
                core.addClass(avatar, constants.CSS_TOUCHCAST_DISABLED);
            }
            var channelImg = (video['user'].channel_image !== '') ? video['user'].channel_image : options.getDefaultAvatarImg();
            core.setAttr(core.find(avatar, 'img'), 'src', channelImg);
            var numComments = video.number_of_comments;
            var recasted = video.recasted;
            var numShares = video.number_of_shares;
            var numRecasts = video.number_of_recasts;
            var numViews = video.number_of_views;
            if (TouchCast.InteractiveLayer.getHLSInfo() !== '') {
                var numComments = TouchCast.InteractiveLayer.getHLSInfo().total_comments;
            }
            if (typeof numViews !== 'undefined' && numViews !== '') {
                var metaInfo = [];
                metaInfo['numComments'] = numComments;
                metaInfo['numShares'] = numShares;
                metaInfo['numRecasts'] = numRecasts;
                metaInfo['numViews'] = numViews;
                metaInfo['recasted'] = recasted;
                self.updateMetaInfos(metaInfo);
            } else {
                if (isAjaxAllowed === 1) {
                    loadData.getPerformanceStats(video.id, function(data) {
                        if (TouchCast.InteractiveLayer.getHLSInfo() !== '') {
                            var numComments = TouchCast.InteractiveLayer.getHLSInfo().total_comments;
                        } else {
                            if (options.getApiUrl() === '' || !options.getApiUrl()) {
                                var numComments = (data.comments_count === 0) ? '' : data.comments_count;
                            } else {
                                var numComments = (data.response.performances.performance.meta.comments_amount === 0) ? '' : data.response.performances.performance.meta.comments_amount;
                            }
                        }
                        if (options.getApiUrl() === '' || !options.getApiUrl()) {
                            var recasted = 0;
                            var numShares = data.no_of_shares;
                            var numRecasts = data.times_recasted;
                            var numViews = data.no_of_views;
                        } else {
                            var recasted = data.response.performances.performance.meta.recasted;
                            var numShares = data.response.performances.performance.meta.number_of_shares;
                            var numRecasts = data.response.performances.performance.meta.times_recasted;
                            var numViews = data.response.performances.performance.meta.number_of_views;
                        }
                        var metaInfo = [];
                        metaInfo['numComments'] = numComments;
                        metaInfo['numShares'] = numShares;
                        metaInfo['numRecasts'] = numRecasts;
                        metaInfo['numViews'] = numViews;
                        metaInfo['recasted'] = recasted;
                        self.updateMetaInfos(metaInfo);
                    });

                }
            }

        },
        updateMetaInfos: function(metaInfo) {
            var numComments = metaInfo['numComments'];
            if (comment)
                comment.updateCommentCount(numComments);

            core.init('.' + constants.CSS_TOUCHCAST_VIDEO_VIEWS + '').html((metaInfo['numViews'] ? metaInfo['numViews'] : '0') + ' ' + language.getInfoBoxVideoStatusViews());
            core.init('.' + constants.CSS_TOUCHCAST_VIDEO_SHARES + '').html((metaInfo['numShares'] ? metaInfo['numShares'] : '0') + ' ' + language.getInfoBoxVideoStatusShares());
            core.init('.' + constants.CSS_TOUCHCAST_VIDEO_RECASTS + '').html((metaInfo['numRecasts'] ? metaInfo['numRecasts'] : '0') + ' ' + language.getInfoBoxVideoStatusRecasts());
            var recastedCount = 0;
            metaInfo['recasted'] ? recastedCount = metaInfo['recasted'] : recastedCount = 0;
            logger.log('Is Recasted-', recastedCount);

            if (this.recastInited === 1) {
                if (metaInfo['recasted'] && metaInfo['recasted'] === "1") {
                    recast.setFlagRecast(metaInfo['recasted']);
                } else {
                    recast.setFlagRecast(0);
                }
                recast.setRecast();
            }
        },
        setPlayerLanguageForInfoModule: function() {
            var tcLangFlagText = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_FLAG_TEXT + '');
            var tcLangBookmarkTooltip = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_BOOKMARK_TOOLTIP + '');
            var tcLangInfoBookmark = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_BOOKMARK_TEXT + '');
            var tcLangFollowTooltip = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_FOLLOW_TOOLTIP + '');
            var tcLangFollow = core.init('#' + constants.CSS_TOUCHCAST_PLAYER_LANGUAGE_INFO_PANEL_FOLLOW_TEXT + '');
            var bookmarkBtn = core.init('.' + constants.CSS_TOUCHCAST_BOOKMARK_BUTTON + '');
            var followBtn = core.init('.' + constants.CSS_TOUCHCAST_FOLLOW_BUTTON + '');
            core.html(tcLangFlagText, language.getInfoBoxFlagText());
            if (options.getUser() && options.getUser() !== null && options.getUser().isBookmarked()) {
                this._updateTooltipster(tcLangBookmarkTooltip, language.getInfoBoxRemoveBookmarkTooltip());
                core.addClass(bookmarkBtn, constants.CSS_TOUCHCAST_BOOKMARKED);
            } else {
                this._updateTooltipster(tcLangBookmarkTooltip, language.getInfoBoxBookmarkTooltip());
                core.removeClass(bookmarkBtn, constants.CSS_TOUCHCAST_BOOKMARKED);
            }
            if (options.getUser() && options.getUser() !== null && options.getUser().isSubscribed()) {
                core.html(tcLangFollow, language.getInfoBoxUnfollowText());
                this._updateTooltipster(tcLangFollowTooltip, language.getInfoBoxUnfollowTooltip());
                core.addClass(followBtn, constants.CSS_TOUCHCAST_SUBSCRIBED);
            } else {
                core.html(tcLangFollow, language.getInfoBoxFollowText());
                this._updateTooltipster(tcLangFollowTooltip, language.getInfoBoxFollowTooltip());
                core.removeClass(followBtn, constants.CSS_TOUCHCAST_SUBSCRIBED);
            }

        },
        setPlayerLanguageForSettingsIcon: function() {
            var tcLangSettingsIcon = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SETTINGS + '');
            this._updateTooltipster(tcLangSettingsIcon, language.getSettingsTooltip());
        },
        setPlayerLanguageForSubtitlesIcon: function() {
            var tcLangSubtitlesIcon = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_TRANSCRIPTIONS + '');

            this._updateTooltipster(tcLangSubtitlesIcon, language.getSubtitleTooltip());
        },
        setPlayerLanguageForSettingsPanel: function() {
            var tcLangSubtitle = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_LABEL + '');
            var tcLangSubtitleHeading = core.init('.' + constants.CSS_TOUCHCAST_CONTROL_BUTTON_SUBTITLES_TITLE + '');
            core.html(tcLangSubtitle, language.getSettingsSubtitleLabel());
            core.html(tcLangSubtitleHeading, language.getSettingsSubtitleListHeading());
        },
        showError: function() {
            var errorContainer = core.init('.' + constants.CSS_TOUCHCAST_ERROR_CONTAINER + '')
            core.hide(core.init('.' + constants.CSS_TOUCHCAST_LOADING_CONTAINER + ''));
            errorContainer.text(constants.CSS_TOUCHCAST_ERROR_TEXT)
            core.show(errorContainer);
        },
        showNotificationError: function(err) {
            var item = core.init('.' + constants.CSS_TOUCHCAST_NOTIFICATION_CONTAINER + '');
            item[0].innerHTML = err;
            core.addClass(item, 'active error');
            setTimeout(function() {
                core.removeClass(item, 'active');
            }, 5000);
        }
    }
});

